<template>
  <participation-agreement-layout>
    <v-container class="w--max--800">
      <v-layout column>
        
        <!-- Header -->
        <v-flex xs12 class="membership-header">
          <div class="header-container">
            <router-link to="/dashboard" class="back-link">
              ← Back to Dashboard
            </router-link>
            <h2 class="title1">Participation Agreement </h2>
          </div>
        </v-flex>

        <!-- Content -->
        <v-flex xs12>
          <v-card flat>
            <v-card-text 
              v-html="item.description" 
              class="app-html-text">
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </participation-agreement-layout>
</template>

<script>
import AppNamePage from '../../../components/app-name-page'
import ParticipationAgreementLayout from './participation-agreement-layout'

export default {
  name: 'participation-agreement',
  mounted() {
    document.title = "NannyGranny Agreement – Secure & Professional Childcare Terms"

    const updateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`)
      if (metaTag) {
        metaTag.setAttribute('content', content)
      } else {
        metaTag = document.createElement('meta')
        metaTag.setAttribute('name', name)
        metaTag.setAttribute('content', content)
        document.head.appendChild(metaTag)
      }
    }

    updateMetaTag('description', "Read our participation agreement to understand the terms of our childcare services. Ensure a safe, reliable, and professional experience for families and caregivers.")
    updateMetaTag('title', 'NannyGranny Agreement – Secure & Professional Childcare Terms')
  },
  components: { ParticipationAgreementLayout, AppNamePage },
  computed: {
    item() {
      return this.$store.getters['page/content']('participation-agreement')[0]
    }
  }
}
</script>

<style scoped>
.membership-header {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.header-container {
  width: 100%;
  /* display: flex; */
  /* margin:20px; */
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.back-link {
  text-decoration: none;
  font-size: 14px;
  color: black;
}
.title1{
    margin-top:30px;
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/content/participation-agreement/index.vue